import zod from 'zod';
import { MANDATORY_FIELD } from '../../config/zodConfig';

export const UserFormSchema = zod
  .object({
    id: zod.string().optional(),
    name: zod.string({ required_error: MANDATORY_FIELD }),
    email: zod.string({ required_error: MANDATORY_FIELD }).email(),
    password: zod.string(),
    phone: zod.string().nullish(),
    cpf: zod.string().optional(),
    cnpj: zod.string().optional(),
    roleIds: zod.array(zod.number()).min(1, MANDATORY_FIELD),
  })
  .superRefine((arg, ctx) => {
    if (!arg.id && !arg.password) {
      ctx.addIssue({
        code: 'custom',
        message: 'Senha obrigatória',
        path: ['password'],
      });
    }
  });
